import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';
import { ASSET_PATH } from 'domain/finance/assets/useAssetService';

export const useAssetUrl = () => {
  const baseUrls = useEntityUrl({ baseLink: ASSET_PATH });

  return { ...baseUrls, getCopyEntityUrl: (id?: string): string => `${baseUrls.getSingleEntityUrl(id)}/copy` };
};

export const useAssetId = () => useParams<Dictionary<string>>().id!;
